<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-card flat>
      <v-layout wrap justify-center pt-9>
        <v-flex xs12 md6 lg6 align-self-center>
          <v-img
            cover
            width="100%"
            :height="$vuetify.breakpoint.name == 'xs' ? '600px' : '450px'"
            class="align-center"
            :src="require('./../../assets/images/Asset4.png')"
          >
            <v-layout wrap justify-center pa-sm-16 px-2>
              <v-flex xs12 align-self-center text-left px-lg-8 px-xl-14 pb-4>
                <span
                  :class="
                    $vuetify.breakpoint.name == 'xs' ? 'title10xs' : 'title10'
                  "
                >
                  PROBLEM STATEMENT
                </span>
              </v-flex>
              <v-flex
                xs12
                align-self-center
                text-justify
                px-lg-8
                px-xl-14
                pb-md-4
                pb-lg-0
              >
                <span class="title11">
                  To develop a centralized information and intelligence management system to collect, process and share actionable intelligence to enforcement agencies and other stakeholders stationed in the tiger ranging countries.
                </span>
              </v-flex>
            </v-layout>
          </v-img>
        </v-flex>
        <v-flex xs12 md6 lg6 align-self-center>
          <v-carousel
            cycle
            height="450"
            hide-delimiter-background
            show-arrows-on-hover
            :show-arrows="false"
            delimiter-icon="mdi-minus"
          >
            <!-- <template v-slot:prev="{ on, attrs }">
              <v-btn color="success" v-bind="attrs" v-on="on"
                >Previous slide</v-btn
              >
            </template> -->
            <!-- <template v-slot:next="{ on, attrs }">
              <v-btn color="info" v-bind="attrs" v-on="on">Next slide</v-btn>
            </template> -->
            <v-carousel-item v-for="(slide, i) in slides" :key="i">
              <v-sheet height="100%">
                <v-row class="fill-height" align="center" justify="center">
                  <v-img
                    cover
                    width="100%"
                    height="450px"
                    class="align-center"
                    :src="slide.url"
                  >
                    <template v-slot:placeholder>
                      <ImageLoader />
                    </template>
                  </v-img>
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
          <!-- <v-img
            cover
            width="100%"
            height="450px"
            class="align-center"
            :src="require('./../../assets/images/Asset5.jpg')"
          >
            <v-layout wrap justify-center>
              <v-flex xs12 align-self-center text-center>
                <span class="title12"> In Service of Nature </span>
              </v-flex>
            </v-layout>
          </v-img> -->
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      vdo: ["./../../assets/videos/Tigers.mp4"],
      colors: [
        "indigo",
        "warning",
        "pink darken-2",
        "red lighten-1",
        "deep-purple accent-4",
      ],
      slides: [
        {
          url: require("./../../assets/images/tiger1.jpg"),
        },
        {
          url: require("./../../assets/images/tiger2.jpg"),
        },
        {
          url: require("./../../assets/images/tiger3.jpg"),
        },
        {
          url: require("./../../assets/images/tiger4.jpg"),
        },
      ],
    };
  },
};
</script>
